// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.88.0-beta.02518ba6',
  revision: '02518ba6',
  branch: 'develop',
  date: 'Mon, 27 Apr 2026 14:55:52 GMT'
};